import { isIos } from "@/utils/lodash"; // 基准大小

var baseSize = 32; // 设置 rem 函数

function setRem() {
  // if (isIos()) {
  //   // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
  //   const scale = document.documentElement.clientWidth / 750;
  //   // 设置页面根节点字体大小
  //   document.documentElement.style.fontSize =
  //     baseSize * Math.min(scale, 2) + "px";
  // } else {
  //   const dpr = window.devicePixelRatio;
  //   let scale;
  //   // 大于等于3的情况下，屏幕越大，越影响
  //   const clientWidth = document.documentElement.clientWidth;
  //   if (dpr >= 2.5 && clientWidth > 360) {
  //     scale = (clientWidth - (clientWidth - 360) * 0.7) / 750;
  //   } else {
  //     scale = clientWidth / 750;
  //   }
  //   document.documentElement.style.fontSize =
  //     baseSize * Math.min(scale, 2) + "px";
  // }
  var dpr = window.devicePixelRatio;
  var scale; // 大于等于3的情况下，屏幕越大，越影响

  var clientWidth = document.documentElement.clientWidth;

  if (dpr >= 2.5 && clientWidth > 360) {
    scale = (clientWidth - (clientWidth - 360) * 0.7) / 750;
  } else {
    scale = clientWidth / 750;
  }

  document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + "px";
} // 初始化


setRem(); // 改变窗口大小时重新设置 rem

window.onresize = function () {
  setRem();
};